import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Tables from "./pages/Tables";
import Categorie from "./pages/categorie";
import Customers from "./pages/customers";
import Post from "./pages/Post";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Etablissement from "./pages/Etablissement";
import Admins from "./pages/Admins";
import Collections from "./pages/collections";
import ProtectedRoute from "./Protected"; // Import the ProtectedRoute component
import Reward from "./pages/reword";
import Signalement from "./pages/Signalement";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <Switch>
        {/* Public Routes */}
        <Route path="/login" exact component={SignUp} />
        {/* Protected Routes */}
        <Main>
          <ProtectedRoute exact path="/dashboard" component={Home} />
          <ProtectedRoute exact path="/tables" component={Tables} />
          <ProtectedRoute exact path="/admins" component={Admins} />
          <ProtectedRoute exact path="/signalement" component={Signalement} />
          <ProtectedRoute exact path="/contact" component={Contact} />

          <ProtectedRoute exact path="/collections" component={Collections} />
          <ProtectedRoute
            exact
            path="/Etablissement"
            component={Etablissement}
          />
          <ProtectedRoute exact path="/customers" component={Customers} />
          <ProtectedRoute exact path="/reward" component={Reward} />
          <ProtectedRoute exact path="/posts" component={Post} />
          <ProtectedRoute exact path="/billing" component={Billing} />
          <ProtectedRoute exact path="/rtl" component={Rtl} />
          <ProtectedRoute exact path="/profile" component={Profile} />

          {/* Redirect all other routes to /dashboard */}
          <Redirect from="*" to="/Etablissement" />
        </Main>
      </Switch>
    </div>
  );
}

export default App;
